import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex",
    "align-items": "center"
  },
  class: "pagination_"
};
import { reactive, watch } from 'vue';
export default {
  __name: 'pagination',
  props: {
    total: {
      type: Number // 总条数
    },
    limit: {
      type: Number // 每页的条数
    },
    page: {
      type: Number // 当前页
    }
  },
  emits: ['handle_limit', 'handle_page'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emit = __emit;
    var props = __props;
    var data = reactive({
      page_child: props.page,
      limit_child: props.limit,
      total_child: props.total,
      optionsPageSize: [{
        label: '15',
        value: 15
      }, {
        label: '20',
        value: 20
      }, {
        label: '50',
        value: 50
      }, {
        label: '100',
        value: 100
      }, {
        label: '500',
        value: 500
      }, {
        label: '1000',
        value: 1000
      }]
    });
    // 改变每页数量
    var handleSizeChange = val => {
      data.limit_child = Number(val);
      emit('handle_limit', Number(val));
    };
    //改变页码
    var handleCurrentChange = val => {
      data.page_child = Number(val);
      emit('handle_page', Number(val));
    };
    var focus = () => {
      console.log("失去了焦点");
      data.page_child = 1;
      emit('handle_page', 1);
    };
    watch(() => props.limit, (newVal, oldVal) => {
      console.log(newVal, oldVal);
      data.limit_child = newVal;
    }, {
      immediate: true
    });

    // 监听 page 属性
    watch(() => props.page, (newVal, oldVal) => {
      console.log('页数发生了改变------->', newVal, oldVal);
      data.page_child = newVal;
    }, {
      immediate: true
    });

    // 监听 total 属性
    watch(() => props.total, newVal => {
      data.total_child = newVal;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _component_el_pagination = _resolveComponent("el-pagination");
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_pagination, {
        total: data.total_child,
        "current-page": data.page_child,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => data.page_child = $event),
        "page-sizes": [15, 20, 50, 100, 500, 1000],
        "page-size": data.limit_child,
        background: "",
        class: "foot",
        layout: "total,prev, pager, next, jumper",
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["total", "current-page", "page-size"]), _cache[2] || (_cache[2] = _createTextVNode("   ")), _createVNode(_component_el_select, {
        modelValue: data.limit_child,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.limit_child = $event),
        filterable: "",
        "allow-create": "",
        "default-first-option": "",
        style: {
          "float": "left",
          "width": "100px"
        },
        onChange: handleSizeChange,
        onFocus: focus
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.optionsPageSize, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value,
            size: "mini"
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _cache[3] || (_cache[3] = _createElementVNode("span", {
        style: {
          "font-size": "13px",
          "line-height": "28px"
        }
      }, "  条/页", -1))]);
    };
  }
};